/**
 * Modalidades de loteria reconhecidas no título dos resultados. Cada uma tem o
 * slug (a chave) e o nome que aparece no quadro "outros resultados".
 */
import { Button } from '@/components/atoms';
import type { ErroDeCampo, Modalidade } from '@/types/portal';

import { CampoTexto } from './campos';
import { erroDe, mover, remover, trocar } from './helpers';
import styles from './Portal.module.css';

interface Props {
  modalidades: Modalidade[];
  onChange: (m: Modalidade[]) => void;
  erros: ErroDeCampo[];
  campo: string;
}

export function EditorModalidades({ modalidades, onChange, erros, campo }: Props) {
  const erroLista = erroDe(erros, campo);
  return (
    <div>
      <h4 className={styles.sub2}>Modalidades ({modalidades.length})</h4>
      {modalidades.length === 0 ? (
        <p className={styles.vazio}>Nenhuma modalidade.</p>
      ) : (
        <ol className={styles.lista} aria-label="Modalidades">
          {modalidades.map((m, i) => (
            <li key={i} className={styles.linha}>
              <div className={styles.linhaCampos}>
                <CampoTexto
                  rotulo={`Chave da modalidade ${i + 1}`}
                  valor={m.slug}
                  mono
                  maxLength={80}
                  erro={erroDe(erros, `${campo}.${i}.slug`)}
                  onChange={(slug) => onChange(trocar(modalidades, i, { ...m, slug }))}
                />
                <CampoTexto
                  rotulo={`Nome da modalidade ${i + 1}`}
                  valor={m.nome}
                  maxLength={40}
                  erro={erroDe(erros, `${campo}.${i}.nome`)}
                  onChange={(nome) => onChange(trocar(modalidades, i, { ...m, nome }))}
                />
              </div>
              <div className={styles.linhaAcoes}>
                <Button
                  type="button"
                  size="sm"
                  variant="ghost"
                  disabled={i === 0}
                  onClick={() => onChange(mover(modalidades, i, i - 1))}
                  aria-label={`Subir modalidade ${i + 1}`}
                >
                  Subir
                </Button>
                <Button
                  type="button"
                  size="sm"
                  variant="ghost"
                  disabled={i === modalidades.length - 1}
                  onClick={() => onChange(mover(modalidades, i, i + 1))}
                  aria-label={`Descer modalidade ${i + 1}`}
                >
                  Descer
                </Button>
                <Button
                  type="button"
                  size="sm"
                  variant="ghost"
                  onClick={() => onChange(remover(modalidades, i))}
                  aria-label={`Remover modalidade ${i + 1}`}
                >
                  Remover
                </Button>
              </div>
            </li>
          ))}
        </ol>
      )}
      {erroLista && <span className={styles.erroCampo}>{erroLista}</span>}
      <div style={{ marginTop: 'var(--sp-2)' }}>
        <Button
          type="button"
          size="sm"
          variant="secondary"
          disabled={modalidades.length >= 20}
          onClick={() => onChange([...modalidades, { slug: '', nome: '' }])}
        >
          Adicionar modalidade
        </Button>
      </div>
    </div>
  );
}
